import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import { DragSource, DropTarget } from 'react-dnd';
import '../../../css/flow/navigation-editor.less';

const renderNavigationItem = props => React.createElement(NavigationItem, props);

const itemSource = {
    beginDrag (props, monitor, component) {
        return {
            id: manywho.utils.getObjectDataProperty(props.item.properties, 'Id').contentValue,
            order: manywho.utils.getObjectDataProperty(props.item.properties, 'Order').contentValue,
            parent: props.parent
        };
    }
};

const itemTarget = {
    canDrop(props, monitor) {
        const { parent: parent } = monitor.getItem();
        return parent && props.findItem(manywho.utils.getObjectDataProperty(props.item.properties, 'Id').contentValue, manywho.utils.getObjectDataProperty(parent.properties, 'NavigationItems').objectData);
    },
    hover (props, monitor, component) {
        const { id: draggedId, parent: parent } = monitor.getItem();
        const overId = manywho.utils.getObjectDataProperty(props.item.properties, 'Id').contentValue;

        if (draggedId !== overId && monitor.isOver({ shallow: true })) {
            const item = props.findItem(overId, props.items);
            const overIndex = manywho.utils.getObjectDataProperty(item.properties, 'Order').contentValue;
            props.moveItem(parent, draggedId, overIndex);
        }
    }
};

@DropTarget('navItem', itemTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget()
}))
@DragSource('navItem', itemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
}))
class NavigationItem extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { connectDragSource, connectDropTarget, isDragging } = this.props;

        const children = manywho.utils.getObjectDataProperty(this.props.item.properties, 'NavigationItems').objectData;
        const label = manywho.utils.getObjectDataProperty(this.props.item.properties, 'Label').contentValue;
        const id = manywho.utils.getObjectDataProperty(this.props.item.properties, 'Id').contentValue;

        const childMenuClass = this.props.isTopLevel ? ['navigation-item', 'dropdown']: ['navigation-item', 'dropdown-submenu'];
        const navigationItemIcon = this.props.isTopLevel ? <span>{label} <b className="caret"></b></span> : label;

        const childItems = children || [];
        const items = childItems
            .sort((item1, item2) => {
                return parseInt(manywho.utils.getObjectDataProperty(item1.properties, 'Order').contentValue) - parseInt(manywho.utils.getObjectDataProperty(item2.properties, 'Order').contentValue);
            })
            .map((child) => {
                const key = manywho.utils.getObjectDataProperty(child.properties, 'Id').contentValue;
                return renderNavigationItem({ items: this.props.items, parent: this.props.item, item: child, key: key, isTopLevel: false, moveItem: this.props.moveItem, itemClick: this.props.itemClick, addItem: this.props.addItem, findItem: this.props.findItem });
            });

        items.push(<li className="add-item" onClick={this.props.addItem.bind(null, id)}><a href="#"><Glyphicon glyph="plus"></Glyphicon></a></li>);

        const opacity = isDragging ? 0 : 1;

        const navigationItem = connectDragSource(<li id={id} key={id} className={childMenuClass.join(' ')} onClick={this.props.itemClick} style={{ opacity: opacity }}>
                            <a href="#">{navigationItemIcon}</a>
                            <ul className="dropdown-menu">
                                {items}
                            </ul>
                        </li>);

        return connectDropTarget(navigationItem)
    }

}

export default NavigationItem;
